// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3j2xC","inputWrap":"Table_inputWrap__1C17N","col":"Table_col__3Al2t","bmiTooltip":"Table_bmiTooltip__2c-5L"};